"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stamp = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _sdk = require("../../../../sdk");
var _statusFieldHelpers = require("../../data/statusFieldHelpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// the construction of this component was guided by StampView.js in plangrid/tasks-frontend,
// which works well for PlanGrid. The implementation here is quite similar.

// this just defines the size for the purpose of building the SVG, the eventual size can be anything.
const SIZE = 44;
const Stamp = _ref => {
  let {
    size,
    text,
    status
  } = _ref;
  // the default display should appear as if the issue is open,
  // (we can't use an enum as a default, so we do it this way)
  status = status || _sdk.IssueStatus.Open;
  const fillColor = (0, _statusFieldHelpers.getStatusColor)(status);
  const strokeColor = (0, _statusFieldHelpers.getStatusTextColor)(status);
  const iconWidth = SIZE * 0.8;
  const iconOffset = (SIZE - iconWidth) / 2;
  return /*#__PURE__*/_react.default.createElement("svg", {
    height: size,
    width: size,
    viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE),
    key: "checkmark-".concat(status, "-").concat(text)
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    strokeWidth: 2,
    stroke: fillColor,
    r: "18",
    cx: SIZE / 2,
    cy: SIZE / 2,
    fill: fillColor
  })),
  // the default code is a unicode checkmark, and we want to render that one in a special way.
  // otherwise, render whatever the text is
  text && text !== "✓" ? /*#__PURE__*/_react.default.createElement("text", {
    x: SIZE / 2,
    y: SIZE / 2,
    dy: "6px",
    fontFamily: "Artifakt Element",
    fontSize: text.length === 3 ? "16px" : "18px",
    textAnchor: "middle",
    style: {
      fontWeight: 600
    },
    fill: strokeColor
  }, text) : /*#__PURE__*/_react.default.createElement(_alloyReactIcon.CheckmarkIcon, {
    size: iconWidth,
    x: iconOffset,
    y: iconOffset + 1,
    color: strokeColor
  }));
};
exports.Stamp = Stamp;
//# sourceMappingURL=Stamp.js.map